import { render, staticRenderFns } from "./ProcessPersonCharge.vue?vue&type=template&id=65c9195a"
import script from "./ProcessPersonCharge.vue?vue&type=script&lang=js"
export * from "./ProcessPersonCharge.vue?vue&type=script&lang=js"
import style0 from "./ProcessPersonCharge.vue?vue&type=style&index=0&id=65c9195a&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports